export default function ServiceDetails({children, img, title, id}) {
    return (
        <div className="mb-6">
            <hr className="mt-2 mb-5"/>
            <h2 id={id} className="mb-3 text-[#0a2540] text-xl font-semibold scroll-mt-24">{title}</h2>
            <div className="text-gray-700 leading-relaxed text-justify">
                <img
                    src={img}
                    alt={title}
                    className="w-24 h-24 rounded-xl float-left mr-4 mb-2"
                />
                {children}
            </div>
        </div>
    );
}
